import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) GeoMobile GmbH, 2022
 */
import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { AppNavbarContainer } from '../../components/AppNavbar.container';
export var DashboardView = function (props) {
    var navigate = useNavigate();
    useEffect(function () {
        var _a;
        if (!((_a = props.token) === null || _a === void 0 ? void 0 : _a.length) && !props.isLoggedIn) {
            navigate('/login');
        }
    }, [props.token, props.isLoggedIn]);
    var renderDashboard = function () {
        return (_jsx(_Fragment, { children: _jsx("div", { className: 'h-full bg-gray-50', children: _jsxs("div", { className: 'h-full', children: [_jsx(AppNavbarContainer, {}), _jsx("div", { className: 'py-10', children: _jsx("main", { children: _jsx("div", { className: 'mx-auto max-w-7xl sm:px-6 lg:px-8', children: _jsx(Outlet, {}) }) }) })] }) }) }));
    };
    return renderDashboard();
};
